import { render } from "./register.vue?vue&type=template&id=680c779c&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=680c779c&scoped=true&lang=css"

import exportComponent from "D:\\project2025\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680c779c"]])

export default __exports__